import { Sky } from "@react-three/drei";
import { useState, useEffect } from "react";
import SunCalc from 'suncalc'; // Import de SunCalc bibliotheek

export const Light = () => {

  // Zet de locatie van België (voorbeeld: Brussel) en tijdstip van de dag
  const location = { lat: 50.8503, lon: 4.3517 }; // Brussel, België

  const customTime = new Date("06/06/2028")
  customTime.setHours(14,15,15)
  // Functie om de zonpositie te berekenen
  const now = customTime; //new Date() // 
  console.log(now)
  const sun = SunCalc.getPosition(now, location.lat, location.lon);

  // De zonpositie in 3D coördinaten: [x, y, z]
  const sunPosition = [sun.azimuth, sun.altitude, 0];

  // Pas turbidity, rayleigh en lichtintensiteit aan op basis van het uur van de dag
  const hour = now.getHours();
  const isDaytime = hour >= 6 && hour <= 18; // Alleen overdag effecten toepassen

  let turbidity = isDaytime ? (0.1 + (hour / 24) * 0.5) : 0.3; // Variatie afhankelijk van tijd van de dag
  let rayleigh = isDaytime ? (0.1 + (hour / 24) * 0.2) : 0.05; // Variatie afhankelijk van tijd van de dag
  let intensity = isDaytime ? 2 : 0.1; // Intensiteit van zonlicht (overdag hoog, 's nachts laag)

  return (
    <>
      {/* Sky achtergrond */}
      <Sky sunPosition={sunPosition} turbidity={turbidity} rayleigh={rayleigh} />

      {/* Zonlicht met verbeterde schaduwen */}
      <directionalLight
        position={sunPosition}
        intensity={intensity} // Dynamische intensiteit
        castShadow
        shadow-mapSize={[4096, 4096]} // Zeer hoge resolutie schaduwen
        shadow-camera-far={200}
        shadow-camera-left={-100}
        shadow-camera-right={100}
        shadow-camera-top={100}
        shadow-camera-bottom={-100}
        shadow-camera-near={0.1}
        shadow-bias={-0.0001}
        shadow-normalBias={0.025}
        shadow-radius={2.5}
      />

      {/* Extra ambient light voor zachte belichting */}
      <ambientLight intensity={0.4} />
    </>
  );
};
